import { LeftAlignedPageContent } from '../../../components/LayoutComponents'
import styled from 'styled-components'
import useQuery from '../../../hooks/useQuery'
import GenericReceipt from './GenericReceipt'

import { InfoPanel, InfoPanelGrey } from './ReceiptComponents'

const Heading = styled.span`
  font-size: 28px;
  margin-bottom: 8px;
  font-weight: 600;
  color: ${({ theme }) => theme.palette.nswStatusInfoBlue};
`
Heading.displayName = 'Heading'

const CouncilInfoItem = styled.div`
  display: flex;
  flex-direction: row;
  margin: 4px 0px;
`
CouncilInfoItem.displayName = 'CouncilInfoItem'

const InfoPanelP = styled.p`
  margin: 4px 0px;
`
InfoPanelP.displayName = 'InfoPanelP'

const LinkText = styled.a`
  font-weight: 800;
  text-decoration: underline;
`
LinkText.displayName = 'LinkText'

function ComplaintsReceipt({ formId }: { formId: number }) {
  const { councilName, councilPhoneNumber, councilFax, councilEmail } =
    useQuery()

  if (!councilName) {
    return <GenericReceipt formId={formId} />
  }

  return (
    <LeftAlignedPageContent>
      {councilName !== 'unsure' ? (
        <>
          <InfoPanel>
            <Heading>Thank you</Heading>
            <br />
            <InfoPanelP>
              It appears your complaint should be reported to the local council
              for the business where the issue occurred.
            </InfoPanelP>
            <InfoPanelP>
              The council area you selected is: <b>{councilName.toString()}</b>
            </InfoPanelP>
            <InfoPanelP>Please contact the local council directly.</InfoPanelP>
          </InfoPanel>
          <InfoPanelGrey>
            <CouncilInfoItem>
              <span>
                <b>Council: </b> {councilName.toString()}
              </span>
            </CouncilInfoItem>
            {councilPhoneNumber && (
              <CouncilInfoItem>
                <span>
                  <b>Phone:</b> {councilPhoneNumber.toString()}
                </span>
              </CouncilInfoItem>
            )}
            {councilFax && (
              <CouncilInfoItem>
                <span>
                  <b>Fax:</b> {councilFax.toString()}
                </span>
              </CouncilInfoItem>
            )}
            {councilEmail && (
              <CouncilInfoItem>
                <span>
                  <b>Email:</b>{' '}
                  <LinkText href={`mailto:${councilEmail}`}>
                    {councilEmail.toString()}
                  </LinkText>
                </span>
              </CouncilInfoItem>
            )}
          </InfoPanelGrey>
          <InfoPanel>
            <span>
              If you think this may not be the correct council for the business
              you wish to complain about, you can look up the council on the{' '}
              <LinkText href="https://www.olg.nsw.gov.au/">
                Office of Local Government website
              </LinkText>
              .
            </span>
          </InfoPanel>
        </>
      ) : (
        <InfoPanel>
          <Heading>Thank you</Heading>
          <br />
          <InfoPanelP>
            It appears your complaint should be reported to the local council
            for the business where the issue occurred.
          </InfoPanelP>
          <InfoPanelP>
            You can look up the council and details to contact it directly using
            the address of the food business: go to the{' '}
            <LinkText href="https://www.olg.nsw.gov.au/">
              Office of Local Government website
            </LinkText>
            .
          </InfoPanelP>
        </InfoPanel>
      )}
    </LeftAlignedPageContent>
  )
}

export default ComplaintsReceipt
